import React from 'react';
import DeviceDrivenInspectionChecklist from '../../components/inspection/DeviceDrivenInspectionChecklist';

/** Admin-visible mirror of technician device-registry checklist (parity). */
export default function AdminInspectionDeviceChecklist(): React.JSX.Element {
    return <DeviceDrivenInspectionChecklist basePath="/admin/inspections" />;
}
